import React from "react";

interface CalendarIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export function CalendarIcon(props: CalendarIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="2" y="3" width="12" height="11" rx="1" />
      <line x1="5" y1="1" x2="5" y2="4" strokeLinecap="round" />
      <line x1="11" y1="1" x2="11" y2="4" strokeLinecap="round" />
      <line x1="2" y1="6" x2="14" y2="6" />
    </svg>
  );
}
